import './Overlay-43cda449.css';

var classes = {"Overlay":"prc-Overlay-Overlay-dVyJl"};

export { classes as default };
